import React from "react";
import PropTypes from "prop-types";

export const BrewStatsBar = ({ brewStats, userInfo, nextBrewDate }) => {
  const isExplorerPlan =
    userInfo && userInfo.user && userInfo.user.access_type === 0;

  return (
    <div
      className="col-md-12"
      style={{
        padding: "12px 20px",
        background: "#f9f6f0",
        borderBottom: "1px solid #e8e0d0",
        marginBottom: "8px",
      }}
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
          flexWrap: "wrap",
          gap: "16px",
        }}
      >
        <strong
          style={{
            fontSize: "11px",
            color: "#888",
            letterSpacing: "1px",
          }}
        >
          YOUR BREW STATS
        </strong>
        <span
          style={{
            width: "1px",
            height: "16px",
            background: "#ddd",
            display: "inline-block",
          }}
        />
        <span style={{ fontSize: "13px", color: "#555" }}>
          Total brews:{" "}
          <strong style={{ color: "#222" }}>
            {brewStats ? brewStats.total_brews : 0}
          </strong>{" "}
          · Kit brews:{" "}
          <strong style={{ color: "#222" }}>
            {brewStats ? brewStats.kit_brews : 0}
          </strong>{" "}
          · Custom brews:{" "}
          <strong style={{ color: "#222" }}>
            {brewStats ? brewStats.custom_brews : 0}
          </strong>
        </span>
      </div>
      {isExplorerPlan && (
        <div
          style={{
            marginTop: "8px",
            display: "inline-flex",
            alignItems: "center",
            gap: "8px",
            padding: "6px 12px",
            background: "#fff8e1",
            border: "1px solid #f0c030",
            borderRadius: "8px",
          }}
        >
          {nextBrewDate ? (
            <span style={{ fontSize: "12px", color: "#854F0B" }}>
              Next custom brew available:{" "}
              <strong>
                {new Date(nextBrewDate).toLocaleDateString("en-US", {
                  year: "numeric",
                  month: "long",
                  day: "numeric",
                })}
              </strong>
            </span>
          ) : (
            <span style={{ fontSize: "12px", color: "#854F0B" }}>
              Explorer plan: 1 custom brew per 8 weeks
            </span>
          )}
          <span style={{ color: "#ddd" }}>·</span>
          <a
            href="https://minibrew.io/collections/subscription"
            style={{
              fontSize: "12px",
              color: "#c8720a",
              fontWeight: "500",
            }}
          >
            Upgrade to Pro →
          </a>
        </div>
      )}
    </div>
  );
};

BrewStatsBar.propTypes = {
  brewStats: PropTypes.shape({
    total_brews: PropTypes.number,
    kit_brews: PropTypes.number,
    custom_brews: PropTypes.number,
  }),
  userInfo: PropTypes.object,
  nextBrewDate: PropTypes.string,
};

BrewStatsBar.defaultProps = {
  brewStats: null,
  userInfo: null,
  nextBrewDate: null,
};

export default BrewStatsBar;
